import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { useDispatch, useSelector } from 'react-redux';

import Autocomplete from '@gef-ui/form-material/Autocomplete';
import SubmitButton from '@gef-ui/form-material/SubmitButton';
import TextField from '@gef-ui/form-material/TextField';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { codelists } from 'constants/codelists';
import { MaxLengths } from 'constants/forms';
import { resetCriteria, submitForm } from 'features/views/campaignDashboards/campaigns/actions';
import { FIELDS } from 'features/views/campaignDashboards/campaigns/form';
import { getCodelistByName } from 'utils/codelists';

export const Form = () => {
	const dispatch = useDispatch();

	const campaignChannels = useSelector(getCodelistByName(codelists.campaignChannels));
	const handleReset = useCallback(() => {
		dispatch(resetCriteria());
	}, [dispatch]);

	const handleSubmit = useCallback(() => {
		// false "initilizingFetch" parameter
		dispatch(submitForm(false));
	}, [dispatch]);

	return (
		<Grid container>
			<Grid size={12}>
				<Grid container spacing={2}>
					<Grid size={8}>
						<TextField
							size="small"
							fieldName={FIELDS.campaignName}
							label={getLabelMessage('campaigns:name')}
							slotProps={{
								htmlInput: {
									maxLength: MaxLengths.NAME,
								},
							}}
						/>
					</Grid>
					<Grid size={4}>
						<Autocomplete
							size="small"
							fieldName={FIELDS.channel}
							label={getLabelMessage('campaigns:channel')}
							options={campaignChannels}
							labelPropName="description"
							valuePropName="id"
						/>
					</Grid>
					<Grid size={6} />
					<Grid size={3}>
						<Button variant="outlined" onClick={handleReset} fullWidth>
							{getLabelMessage('common:resetButton')}
						</Button>
					</Grid>
					<Grid size={3}>
						<SubmitButton
							variant="contained"
							onClick={handleSubmit}
							fullWidth
							text={getLabelMessage('common:searchButton')}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

Form.propTypes = {
	onReset: PropTypes.func,
	onSubmit: PropTypes.func,
};

export default Form;
